import { toutesPresentes } from '@/lib/controle';
import type { AffirmationControle } from '@rosetta/shared';
import { PuceCode } from './puce-code';

interface DetailAffirmationsProps {
  affirmations: readonly AffirmationControle[];
}

/**
 * What the "Fidélité des affirmations" card details (indicator 2.2): each affirmation of the text
 * of origin, as the inventory of Tahiti words it, with its state (the code of Tahiti). When all
 * are "presente", one line says that none was lost or altered (A8). An affirmation Tahiti says
 * something about (its `detail`) shows the passage of the translation and that sentence.
 */
export function DetailAffirmations({ affirmations }: DetailAffirmationsProps) {
  if (affirmations.length === 0) return null;
  return (
    <>
      {toutesPresentes(affirmations) ? (
        <p className="mt-3 font-semibold text-small leading-normal">
          Aucune affirmation perdue ou altérée.
        </p>
      ) : null}
      <ul aria-label="affirmations du texte d'origine" className="mt-2">
        {affirmations.map((affirmation, rang) => (
          <li
            // biome-ignore lint/suspicious/noArrayIndexKey: the order is Tahiti's and never changes.
            key={rang}
            className="flex items-baseline justify-between gap-4 border-gray-100 border-t py-2 text-small leading-normal"
          >
            <div className="min-w-0">
              <p>{affirmation.texte}</p>
              {affirmation.detail === undefined ? null : (
                <>
                  {affirmation.passage === undefined ? null : (
                    <p className="mt-1 font-light text-small">
                      «&nbsp;{affirmation.passage}&nbsp;»
                    </p>
                  )}
                  <p className="mt-1 text-gray-700">{affirmation.detail}</p>
                </>
              )}
            </div>
            <PuceCode>{affirmation.etat.libelle}</PuceCode>
          </li>
        ))}
      </ul>
    </>
  );
}
